import React from 'react';
import { Button, Form, Modal } from "react-bootstrap";

const DocumentsAddModal = ({ show, handleClose }) => {
    return (
        <>
            <Modal show={show} onHide={handleClose}>
                <Modal.Header className="border-0" closeButton>
                    <Modal.Title className="h5">Add Document</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form >
                        <Form.Group className="mb-3">
                            <Form.Label>Title:</Form.Label>
                            <Form.Control type="text" placeholder="Enter title" />
                        </Form.Group>
                        
                        <Form.Group className="mb-3">
                            <Form.Label>Upload File:</Form.Label>
                            <Form.Control type="file" />
               
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer className="border-0">
                    <Button variant="primary" onClick={handleClose}>
                        Save
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default DocumentsAddModal;